import React from 'react'
import { Check, Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface WorkspaceMenuPortalProps {
  menuPortalRef: React.RefObject<HTMLDivElement>
  menuPosition: { top: number; left: number }
  searchInputRef: React.RefObject<HTMLInputElement>
  searchQuery: string
  setSearchQuery: (query: string) => void
  filteredWorkspaces: string[]
  handleChangeActiveWorkspace: (workspaceId: string) => void
  user: any
  workspaces: any
}

export const WorkspaceMenuPortal = ({
  menuPortalRef,
  menuPosition,
  searchInputRef,
  searchQuery,
  setSearchQuery,
  filteredWorkspaces,
  handleChangeActiveWorkspace,
  user,
  workspaces,
}: WorkspaceMenuPortalProps) => {
  const navigate = useNavigate()

  return (
    <div
      ref={menuPortalRef}
      className="p-2 bg-white dark:bg-gray-800 shadow rounded border border-grey-200 dark:border-gray-700 z-50 flex flex-col"
      style={{ position: 'fixed', top: menuPosition.top, left: menuPosition.left, width: 200, maxHeight: 400 }}
    >
      {/* Search Input */}
      <div className="pb-2 px-1">
        <input
          ref={searchInputRef}
          type="text"
          placeholder="Search workspaces..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full px-2 py-1.5 text-[13px] border border-grey-200 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-black dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#FF4A8E]"
          onClick={(e) => e.stopPropagation()}
        />
      </div>

      {/* Scrollable workspace list */}
      <div className="overflow-y-auto" style={{ maxHeight: 280 }}>
        {filteredWorkspaces.length > 0 ? (
          filteredWorkspaces.map((workspace) => (
            <button
              key={workspace}
              className="p-1 flex items-center gap-[8px] my-[5px] w-full hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
              onClick={() => handleChangeActiveWorkspace(workspace)}
            >
              {user.active_workspace === workspace ? (
                <>
                  <Check className="w-[17px] h-[17px] text-[#FF4A8E]" strokeWidth={2} />
                  <p className="opacity-80 text-black dark:text-white text-[13px] font-bold font-['Manrope'] leading-none">
                    {workspaces[workspace].name}
                  </p>
                </>
              ) : (
                <p className="ml-[25px] opacity-80 text-black dark:text-gray-300 text-[13px] font-medium font-['Manrope'] leading-none">
                  {workspaces[workspace].name}
                </p>
              )}
            </button>
          ))
        ) : (
          <div className="px-2 py-4 text-center">
            <p className="text-[13px] text-gray-500 dark:text-gray-400">No workspaces found</p>
          </div>
        )}
      </div>

      {/* Add Workspace button */}
      {(Object.values(workspaces).some((item) => Object.prototype.hasOwnProperty.call(item, 'plan_id')) ||
        Object.values(workspaces).length < 1) && (
        <button
          className="mx-1 border-t pt-[15px] pb-[8px] border-grey-200 dark:border-gray-700 flex items-center justify-center gap-[14px]"
          onClick={() => navigate('/workspace/create')}
        >
          <Plus className="w-[13px] h-[13px] text-[#FF4A8E]" />
          <p className="opacity-80 text-black dark:text-white text-[13px] font-medium font-['Manrope'] leading-none">
            Add Workspace
          </p>
        </button>
      )}
    </div>
  )
}
